<p *ngFor="let error of errors$ | async" [attr.code]="error.code" [attr.details]="error.details">
  {{error.message}}
</p>
